import { render, staticRenderFns } from "./product-additional-wrapper.vue?vue&type=template&id=1beaab32&"
import script from "./product-additional-wrapper.vue?vue&type=script&lang=ts&"
export * from "./product-additional-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./product-additional-wrapper.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports